import { Link } from "react-router-dom";
import Seo, { SITE_URL } from "@/components/base/Seo";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";
import { categories } from "@/mocks/articles";

export default function Faq() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      inLanguage: "zh-CN",
      url: `${SITE_URL}/faq`,
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: `${SITE_URL}/` },
        { "@type": "ListItem", position: 2, name: "常见问题", item: `${SITE_URL}/faq` },
      ],
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="常见问题 | 看料88 内容收录与查找说明"
        description="关于看料88的内容范围、查找方式、更新频率、投稿方式与版权说明，这里汇总了读者最常问的八个问题，帮你快速了解站点的收录规则。"
        keywords="看料88常见问题,内容收录标准,查找方式,投稿,版权说明"
        path="/faq"
        jsonLd={jsonLd}
      />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-14">
          <Breadcrumbs items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
          <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            常见问题
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里整理了读者最常问到的问题，涵盖内容范围、查找方式、更新频率、投稿与版权说明。如果还有疑问，欢迎通过联系表单告诉我们。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-14">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
            <div className="lg:col-span-8">
              <FaqAccordion items={faqs} defaultOpen={0} />
            </div>

            <aside className="lg:col-span-4">
              <div className="flex flex-col gap-6 lg:sticky lg:top-28">
                <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                  <h2 className="font-heading text-base font-bold text-foreground-950">按栏目浏览</h2>
                  <ul className="mt-3 flex flex-wrap gap-2">
                    {categories.map((cat) => (
                      <li key={cat.key}>
                        <Link
                          to={`/archive?cat=${cat.key}`}
                          className="inline-block rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                        >
                          {cat.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="rounded-lg bg-primary-500 p-5">
                  <h2 className="font-heading text-base font-bold text-background-50">还有别的问题？</h2>
                  <p className="mt-2 text-sm leading-relaxed text-background-100/90">
                    在关于我们页面留下了订阅与联系表单，写下你的疑问或线索，我们会尽快回复。
                  </p>
                  <Link
                    to="/about"
                    className="mt-3 inline-block whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
                  >
                    前往联系我们
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}